import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { StrategicInitiativePillar } from "@/common/strategic-initiatives.ts";

interface StrategicInitiativeFilterProps {
  strategicInitiativePillars: StrategicInitiativePillar[];
  onChange: (filters: string[]) => void;
}

const StrategicInitiativeFilters: React.FC<StrategicInitiativeFilterProps> = ({
  strategicInitiativePillars,
  onChange,
}) => {
  const [
    activeStrategicInitiativePillars,
    setActiveStrategicInitiativePillars,
  ] = useState<StrategicInitiativePillar[]>([]);

  useEffect(() => {
    onChange(activeStrategicInitiativePillars.map((item) => item.pillar));
  }, [activeStrategicInitiativePillars, onChange]);

  const handleFilter = (filter: StrategicInitiativePillar | null) => {
    if (filter === null) {
      setActiveStrategicInitiativePillars([]);
      return;
    }

    const newFilters = [...activeStrategicInitiativePillars];

    const foundFilterIndex = newFilters.findIndex(
      (activeFilter) => activeFilter === filter,
    );

    if (foundFilterIndex === -1) {
      newFilters.push(filter);
    } else {
      newFilters.splice(foundFilterIndex, 1);
    }

    setActiveStrategicInitiativePillars(newFilters);
  };

  return (
    <div className="flex items-center w-full h-[72px] gap-3">
      <Button
        type="button"
        className={`${
          activeStrategicInitiativePillars.length === 0
            ? "bg-sky-500 border-sky-500"
            : "bg-sky-100 border-sky-100 text-black"
        } border rounded-full justify-central hover:bg-sky-200 hover:border-sky-700 hover:text-black`}
        onClick={() => handleFilter(null)}
      >
        All
      </Button>

      <h3 className="text-black font-bold ml-6">Pillar</h3>

      {strategicInitiativePillars.map((item) => (
        <Button
          key={item.rootId}
          type="button"
          className={`${
            activeStrategicInitiativePillars.includes(item)
              ? "bg-sky-500 border-sky-500"
              : "bg-sky-100 border-sky-100 text-black"
          } border rounded-full justify-central hover:bg-sky-200 hover:border-sky-700 hover:text-black`}
          onClick={() => handleFilter(item)}
        >
          {item.title}
        </Button>
      ))}
    </div>
  );
};

export default StrategicInitiativeFilters;
